import React from 'react';
import {FestiveAtmosphere} from './components/ExperienceR36';

import ReactDOM from 'react-dom/client';
import { initializeTheme } from './utils/theme';
import './index.css';
import './theme.css';
import './screen-themes-r19.css';
import './surfaces.css'; // ← Tailwind burada devreye giriyor
import './screen-design.css';
import './reference-screens.css';
import './reference-product.css';
import './revision-r46.css';


const {prepareOfflineDictionary} = require('./offline/prepare');
const prepareOffline = () => {if(navigator.onLine!==false)prepareOfflineDictionary().catch(()=>{});};
window.addEventListener('online',prepareOffline);
if(window.requestIdleCallback)window.requestIdleCallback(prepareOffline,{timeout:3000});else setTimeout(prepareOffline,1000);

const { loadGoogleIdentity } = require('./utils/googleIdentityLoader');
if ((process.env.REACT_APP_KELIMO_GOOGLE_CLIENT_ID || '').trim() && !window.Capacitor?.isNativePlatform?.()) {
  loadGoogleIdentity().catch(() => {});
}

// One explicit upgrade navigation bypasses an older shell without clearing storage.
try{const u=new URL(window.location.href);if(u.searchParams.has('kelimoUpdate')){u.searchParams.delete('kelimoUpdate');window.history.replaceState(window.history.state,'',u.href);}}catch(_){}
const {recordConnectionEvent}=require('./utils/connectionTrace');
recordConnectionEvent('document-start',{buildRevision:document.querySelector('meta[name="kelimo-shell-revision"]')?.content,documentId:window.crypto?.randomUUID?.()||String(Date.now()),navigationType:performance.getEntriesByType?.('navigation')[0]?.type||'unknown'});
initializeTheme();
const {cachedTheme,applyScreenTheme}=require('./utils/screenTheme');
const themeOwner=sessionStorage.getItem('username');
if(themeOwner&&sessionStorage.getItem('reconnectToken'))applyScreenTheme(null,cachedTheme(themeOwner));
window.addEventListener('kelimo-session-ended',()=>applyScreenTheme(null,null));
if ('serviceWorker' in navigator && window.isSecureContext && !window.Capacitor?.isNativePlatform?.()) {
  navigator.serviceWorker.register('/kelimo-push-sw.js',{scope:'/',updateViaCache:'none'}).then(registration => {
    require('./utils/shellUpdate').watchRegistration(registration);
    // Never reload on controllerchange: a match may be in progress.
  }).catch(() => {});
}

async function start() {
  // Keep the boot screen visible while nonblocking production CSS loads.
  try {
    await Promise.race([new Promise((_,reject)=>setTimeout(()=>reject(Error('Style timeout')),12000)),Promise.all([...document.querySelectorAll('link[data-kelimo-css]')].map(link => link.dataset.kelimoCss==='failed' ? Promise.reject(Error('Style unavailable')) : link.sheet ? Promise.resolve() : new Promise((resolve,reject) => {
      link.addEventListener('load',resolve,{once:true});
      link.addEventListener('error',()=>reject(Error('Style unavailable')),{once:true});
    })))]);
  } catch (_) {
    const boot=document.getElementById('kelimo-boot');
    if(boot){boot.querySelector('span').textContent='Görünüm yüklenemedi. Bağlantını kontrol edip yeniden aç.';}
    return;
  }

  if (window.Capacitor?.isNativePlatform?.()) {
    try {
      if (!window.KelimoNative?.ready) throw new Error('Native bridge missing');
      await Promise.race([window.KelimoNative.ready, new Promise((_, reject) => setTimeout(() => reject(new Error('timeout')), 10000))]);
    } catch (_) {
      const host = document.getElementById('root');
      host.textContent = 'Güvenli oturum açılamadı. ';
      const retry = document.createElement('button'); retry.textContent = 'Yeniden dene';
      retry.onclick = () => window.location.reload(); host.append(retry);
      if (window.KelimoNative?.resetSession) {
        const reset = document.createElement('button'); reset.textContent = 'Bu cihazdaki oturumu sıfırla';
        reset.onclick = async () => {
          reset.disabled = true;
          try { await window.KelimoNative.resetSession(); window.location.reload(); }
          catch (_) { reset.disabled = false; reset.textContent = 'Sıfırlanamadı; tekrar dene'; }
        }; host.append(reset);
      }
      return;
    }
  }
  const App = require('./App').default;
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <><App /><FestiveAtmosphere /><aside className="kelimo-portrait-notice" role="status"><strong>Telefonu dikey konuma çevir</strong><p>Kelimo’yu dikey ekranda oynayabilirsin. Açık oyunda süre işlemeye devam eder.</p></aside></>
);

}
void start();


import './product-polish-v217.css';

import './product-polish-v218.css';
import './product-polish-v219.css';

import './product-polish-v221.css';

import './product-polish-v222.css';

import './product-polish-v223.css';

import './bot-unified-v226.css';

import './product-fixes-v227.css';

import './refinement-v237.css';

import "./refinement-v238.css";

import "./refinement-v239.css";

import "./refinement-v242.css";

import './product-review-r9.css';

import "./product-review-r10.css";

import './product-review-r11.css';

import './product-review-r12.css';

import './product-review-r13.css';

import "./product-review-r14.css";

import './product-review-r15.css';

import './product-review-r16.css';

import './product-review-r17.css';

import './product-review-r18.css';

import './product-r20.css';
import './product-r21.css';

import './material-selection-r21.css';
import './product-r22.css';

import './product-r26.css';

import './product-r27.css';

import './product-r28.css';
import './product-r29.css';

import './product-r30.css';
import './surfaces-r33.css';
import './meaning-actions-r34.css';

import './product-r31.css';

import './release-r35.css';

import './release-r36.css';

import './release-r37.css';

import './release-r38.css';

import './product-r45.css';
